export const AGENCY_KPIS = [
  { label: 'Client Revenue Influenced', value: 84, prefix: '$', suffix: 'M' },
  { label: 'Campaigns Delivered', value: 312, suffix: '+' },
  { label: 'Average Return on Ad Spend', value: 4.6, suffix: 'x', decimals: 1 },
  { label: 'Talent Retention Rate', value: 96, suffix: '%' },
];

export const CASE_STUDIES = [
  {
    sector: 'Performance Automotive',
    client: 'European Motorcycle Marque',
    headline: 'A heritage marque reintroduced to a younger buyer',
    summary:
      'A twelve-week creator programme built around workshop-grade credibility, converting enthusiast audiences into showroom appointments across three markets.',
    metrics: [
      { k: 'Qualified Test Rides', v: '2,140' },
      { k: 'Cost per Lead', v: '−58%' },
      { k: 'Campaign Reach', v: '11.4M' },
    ],
  },
  {
    sector: 'Beauty & Skincare',
    client: 'DTC Skincare Group',
    headline: 'From plateaued spend to profitable scale',
    summary:
      'A full creative rebuild paired with structured Meta testing, retiring fatigued assets and installing a monthly production cadence.',
    metrics: [
      { k: 'ROAS', v: '5.9x' },
      { k: 'Monthly Spend Scaled', v: '$410K' },
      { k: 'New Customers', v: '38,600' },
    ],
  },
  {
    sector: 'Luxury Hospitality',
    client: 'Private Resort Collection',
    headline: 'Direct bookings recaptured from OTAs',
    summary:
      'Editorial-grade production with two roster placements, shifting demand away from third-party platforms and into owned channels.',
    metrics: [
      { k: 'Direct Bookings', v: '+147%' },
      { k: 'Avg. Booking Value', v: '+22%' },
      { k: 'Engagement Rate', v: '9.8%' },
    ],
  },
];